<template>
  <div :class="cardClasses()" :data-theme-filters="themeFilters" :data-type-filters="typeFilters">
    <a @click="onCardLinkSelect($event, card)" :href="link" :class="cardLinkClasses()">
      <span v-if="alfaTag" class="card24251__tag mu-tag">{{ alfaTag }}</span>
      <div class="card24251__cover">
        <div :class="cardImageClasses" :style="{backgroundImage: `url(${getImage})`}">
          <svg v-if="iconFallback" class="card24251__fallback-icon" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><path d="M40.97.272l-.149.005-.206.038c-3.023.756-4.616 3.111-5.335 5.09-.306.842-.464 1.619-.563 2.27-.724-.21-1.591-.539-2.351-.91-1.236-.604-2.203-1.208-2.203-1.208l-.141-.074c-2.822-1.304-6.212-.823-9.131.712-2.919 1.534-5.446 4.174-6.479 7.556-2.252 7.368 2.45 16.249 5.157 22.642.989 2.336 2.68 3.81 4.537 4.537 1.857.727 3.839.772 5.643.553 3.303-.401 5.639-1.572 6.095-1.791.456.218 2.792 1.39 6.095 1.791 1.804.219 3.786.174 5.643-.553 1.857-.727 3.538-2.201 4.527-4.537 2.707-6.393 7.419-15.274 5.167-22.642-1.033-3.382-3.568-6.021-6.486-7.556-2.919-1.534-6.311-2.016-9.133-.712l-.139.074s-.969.604-2.205 1.208c-.637.312-1.356.601-1.999.811.083-.406.19-.842.36-1.307.551-1.514 1.495-2.973 3.552-3.488.624-.143 1.044-.728.98-1.366-.064-.637-.593-1.127-1.233-1.142v-.001zm-14.382 7.01c.863.014 1.673.18 2.374.504.121.075 1.002.63 2.287 1.258 1.315.643 2.858 1.342 4.413 1.387.147.021.296.016.442-.014 1.527-.066 3.03-.739 4.323-1.372 1.289-.63 2.181-1.185 2.297-1.258 1.87-.864 4.497-.606 6.881.647 2.384 1.253 4.443 3.445 5.241 6.057 1.766 5.777-2.306 14.372-5.073 20.905-.75 1.771-1.82 2.661-3.12 3.17-1.301.509-2.879.578-4.415.392-3.073-.373-5.832-1.714-5.832-1.714-.355-.176-.771-.176-1.126 0 0 0-2.766 1.341-5.839 1.714-1.536.186-3.107.117-4.408-.392-1.301-.509-2.371-1.399-3.12-3.17-2.766-6.533-6.838-15.128-5.073-20.905.798-2.613 2.848-4.804 5.231-6.057 1.49-.783 3.078-1.176 4.517-1.151zm21.91 5.688c-.593.007-1.102.422-1.228 1.002-.125.579.167 1.168.704 1.419 0 0 .363.168.843.769.48.6.992 1.545.992 3.168 0 3.246-2.324 6.918-2.324 6.918-.282.377-.332.878-.131 1.303.201.425.62.705 1.09.726.47.022.913-.218 1.152-.623 0 0 2.756-3.95 2.756-8.324 0-2.187-.758-3.775-1.548-4.763-.79-.987-1.697-1.454-1.697-1.454-.188-.097-.398-.146-.61-.141zm-43.058 30.46c-1.794-.001-3.19 1.098-3.984 2.364-.793 1.266-1.143 2.726-1.143 4.031 0 1.291.326 2.74 1.096 4.003.77 1.264 2.146 2.362 3.927 2.361l64.792-.029c.623.001 1.155-.451 1.255-1.067.1-.615-.262-1.212-.853-1.409 0 0-2.942-.919-2.942-3.882s2.942-3.872 2.942-3.872c.592-.197.953-.793.853-1.409-.1-.615-.632-1.067-1.255-1.067l-64.688-.026zm0 2.54l61.434.029c-.867.978-1.828 1.99-1.828 3.805 0 1.816.96 2.84 1.828 3.817l-61.538.029c-.799 0-1.298-.384-1.761-1.144-.463-.76-.722-1.862-.722-2.681 0-.806.278-1.915.759-2.681.481-.767 1.01-1.171 1.828-1.171v-.003zm0 12.705c-1.794-.001-3.19 1.096-3.984 2.361-.793 1.265-1.143 2.719-1.143 4.023 0 1.291.326 2.737 1.096 4.001.77 1.264 2.146 2.375 3.927 2.374l64.792-.038c.623.001 1.155-.451 1.255-1.067.1-.615-.262-1.212-.853-1.409 0 0-2.942-.909-2.942-3.872s2.942-3.872 2.942-3.872c.592-.197.953-.793.853-1.409-.1-.615-.632-1.067-1.255-1.067l-64.688-.026zm0 2.54l61.434.029c-.867.978-1.828 1.993-1.828 3.808 0 1.812.963 2.828 1.828 3.805l-61.538.038c-.799 0-1.298-.391-1.761-1.151-.463-.76-.722-1.862-.722-2.681 0-.806.278-1.907.759-2.674.481-.767 1.01-1.171 1.828-1.171v-.003z" fill-rule="nonzero"/></svg>
          <div class="card24251__wbtag-wrapper">
            <span v-if="warningTag" class="card24251__warning-tag">{{ warningTag }}</span>
            <span v-if="bravoTag" class="card24251__bravo-tag">{{ bravoTag }}</span>
          </div>
          <span v-if="attRequired" class="shoddy-marker"></span>
          <span class="debug-info">{{ cats }}</span>
          <div style="display:flex; align-items:center;">
            <p class="card2451_link-cta">{{ cta }}</p>
            <button class="card24251__link-button" v-if="!desc">
              <i class="material-icons icon">arrow_forward</i>
            </button>
          </div>
        </div>
        <h2 class="card24251__heading" v-html="title"></h2>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    desc: { type: String },
    attRequired: { type: Boolean, required: false },
    card: { type: Object, required: false },
    title: { type: String, required: true },
    image: { type: [String, Boolean], required: false, default: null },
    tags: { type: Object, required: false },
    cats: { type: Object, required: true },
    link: { type: String, required: true },
    warningText: { type: String, required: false },
    subClasses: { type: Array },
    cta: { type: String, required: false },
    types: { type: Array },
    number: { type: Number },
    interval: { type: Number }
  },
  data() {
    return {
      appLang: this.$store.getters.getAppLang,
      tagsList: [],
      isActive: false,
      readyForImage: false
    };
  },
  mounted() {
    if (window.location.href.indexOf('theme') > -1) {
      this.card.readyForImage = true;
      //
    } else if (window.location.href.indexOf('type') > -1) {
      this.card.readyForImage = true;
      //
    } else if (this.interval === 0) {
      this.card.isActive = false;
      this.card.readyForImage = true;
    }
    this.isActive = this.card.isActive;
    this.createTagList();
  },
  computed: {
    iconFallback() {
      // This only (for now) goes so far to check if hard false on image property.
      // For now, that applies only to activity resources.
      // If we end up having other fallback icons, we'll modify accordingly to check filters.types array, etc etc.
      return (this.image === false);
    },
    alfaTag() {
      // To do: Capability to accept more than one.
      if (!this.tags) return;
      return this.tags.alfa ? this.tags.alfa : '';
    },
    bravoTag() {
      if (!this.tags) return;
      return this.tags.bravo ? this.tags.bravo : '';
    },
    warningTag() {
      if (!this.tags) return;
      return this.tags.warning ? this.tags.warning : '';
    },
    themeFilters() {
      return this.cats.themes.toString();
    },
    typeFilters() {
      return this.cats.types.toString();
    },
    getImage() {
      if (this.card.isActive === true && this.card.readyForImage === true) {
        this.imagesrc();
        this.imagesize();
        return this.image ? require(`@/assets/images/compressed/${this.image}`) : '';
      } else {
        return '';
      }
    },
    cardImageClasses() {
      let classes = 'card24251__image card24251__image--cover';
      if (this.image === false) classes += ' card24251__image--none';
      return classes;
    }
  },
  methods: {
    hasWarningTag(card) {
      return !!(card.tags && card.tags.warning);
    },
    onCardLinkSelect(e, card) {
      const hasWarningTag = this.hasWarningTag(card);
      if (hasWarningTag) {
        e.preventDefault();
        this.showWarningModal(card);
      }
    },
    showWarningModal(card) {
      this.$emit('show-warning-modal', [card.warningText, card.link]);
    },
    cardLinkClasses() {
      const baseClass = 'card24251__link';
      let classes = baseClass;
      if (this.desc) {
        classes += ` ${baseClass}--quick-view`;
      } else {
        classes += ` ${baseClass}--quick-view-none`;
      }
      return classes;
    },
    cardClasses() {
      const baseClass = 'card24251';
      let classes = baseClass;
      if (this.card.isActive === false) {
        classes += ' alert card24251__lzLoad ';
      }
      if (!this.subClasses) return classes;
      this.subClasses.forEach((subClass) => {
        classes += ` ${baseClass}--${subClass}`;
      });
      return classes;
    },
    createTagList() {
      // If returned value is a string, add that string to array.
      // But (otherwise / else), if value passed in is an array, re-assign array to localized variable.
      /*  const tagsArr = typeof this.tags !== 'object' ? [this.tags] : this.tags;
      for (const tag of tagsArr) {
        this.tagsList.push(tag);
      } */
      return '';
    },
    async imagesrc() {
      // so we can rerun the masonry when the image has been loaded
      var imagesrc = this.image ? require(`@/assets/images/compressed/${this.image}`) : '';
      var imagesize;
      const imageLoadPromise = new Promise(resolve => {
        imagesize = new Image();
        imagesize.onload = resolve;
        imagesize.src = imagesrc;
      });
      await imageLoadPromise;
      this.$root.$emit('cardActive');
      return imagesrc;
    },
    async imagesize() {
      // For Masonry, putting the (img-height / img-width as a %) as padding-top in the card element with css
      var el = this.$el;
      if (el) {
        var imagesrc = this.image ? require(`@/assets/images/compressed/${this.image}`) : '';
        if (!this.image) {
          el.style.marginBottom = '56px';
          el.style.opacity = '0.0';
          this.$root.$emit('noImage');
        } else el.style.opacity = '0.0';
        var imagesize;
        var size = [];
        var value;
        const imageLoadPromise = new Promise(resolve => {
          imagesize = new Image();
          imagesize.onload = resolve;
          imagesize.src = imagesrc;
        });
        await imageLoadPromise;
        size[0] = imagesize.height;
        size[1] = imagesize.width;
        value = size[0] / size[1] * 100;
        var holder = el.getElementsByClassName('card24251__image');
        holder[0].style.paddingTop = value + '%';
        el.style.marginBottom = '56px';
        this.$root.$emit('CardsGrid');
      }
    }
  }
};
</script>